import { Injectable } from '@angular/core';

import { ActivatedAppointmentResponse, Customer } from '@models';
import { PaymentOptionsEnum } from '@modules/core/enums';
import { ActivatePublicDraftAppointmentRequestDTO, ActivatePublicDraftAppointmentResponseDTO } from '@paymash/sdk/api';

@Injectable({
  providedIn: 'root',
})
export class ActivateAppointmentMapper {
  public mapToEntity(dto: ActivatePublicDraftAppointmentResponseDTO): ActivatedAppointmentResponse {
    return {
      uuid: dto.uuid,
      invoiceUuid: dto.invoiceUuid,
    };
  }

  public mapToDTO(entity: Customer, paymentMethod: PaymentOptionsEnum): ActivatePublicDraftAppointmentRequestDTO {
    return {
      firstName: entity.firstName,
      lastName: entity.lastName,
      email: entity.email,
      phone: entity.phone,
      salutation: entity.salutation,
      comment: entity.comment as string,
      paymentMethod: paymentMethod,
    };
  }
}
